import { render } from "./kalio-library-item-card.vue?vue&type=template&id=d68ace40"
import script from "./kalio-library-item-card.vue?vue&type=script&lang=js"
export * from "./kalio-library-item-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__